import { useEffect, useState, useRef } from "react";
import ImageZoom from "js-image-zoom";
import MetaComponent from "../../components/MetaComponent.js";
import { useParams } from "react-router-dom";
import { useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';
import dayjs from 'dayjs'

// swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/autoplay';
import './../assets/styles.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import { FreeMode, Thumbs } from 'swiper/modules';

const config = require("../../constants/constants.js")
const { strCurrency, strEuroCurrency } = require('../../utils/currencyUtils.js')

const size_linkToAllServices = 40;

const ServiceDetailsPageComponent = ({
  addToCartReduxAction,
  reduxDispatch,
  getServiceDetails,
  userInfo,
  writeReviewApiRequest
}) => {

  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [showCartMessage, setShowCartMessage] = useState(false);
  const [service, setService] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [serviceReviewed, setServiceReviewed] = useState(false);

  let navigate = useNavigate();

  const url_elencoServizi = "/servizi";
  const url_image_elencoServizi = config.URL_IMAGES_CUSTOMER1 + "elenco-servizi.png";
  const help_image_elencoServizi = "elenco dei servizi";

  const messagesEndRef = useRef(null);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  useEffect(() => {
    if (serviceReviewed) {
      setTimeout(() => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }, 200)
    }
  }, [serviceReviewed])

  useEffect(() => {
    if (service.images) {
      var options = {
        // width: 400,
        // zoomWidth: 500,
        // fillContainer: true,
        // zoomPosition: "bottom",
        scale: 2,
        offset: { vertical: 0, horizontal: 0 },
      };

      service.images.map(
        (image, id) =>
          new ImageZoom(document.getElementById(`imageId${id + 1}`), options)
      );
    }
  });

  useEffect(() => {
    getServiceDetails(id)
      .then((data) => {
        setService(data);
        setImages(data?.images);
        setLoading(false);
      })
      .catch((er) =>
        setError(
          er.response.data.message ? er.response.data.message : er.response.data
        )
      );
  }, [id, serviceReviewed]);

  const routeChange = () => {
    //e.preventDefault();
    navigate(url_elencoServizi);
  }

  function verificaTrue(value) {
    if (value === true) {
      return "true";
    } else return "false";
  }

  function verificaContieneCaratteri(value) {
    console.log("[verificaMaggioveDiZero] value =", (value === ""))
    if (value === "") {
      return "true";
    } else return "";
  }

  //  const Item = styled(Paper)(({ theme }) => ({
  //    backgroundColor: '#b6d6e0ff',
  const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#bfdae3ff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 3, md: 3 }}
        paddingLeft={{ xs: 2, md: 6 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          {config.BC_HOME}
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/servizi"
        >
          {config.BC_SERVIZI}
        </Link>
        <Typography sx={{ color: 'text.primary' }}>{service.name}</Typography>
      </Breadcrumbs>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

      <Grid container spacing={2}>

        <Grid
          size={{ xs: 1, md: 1 }}
          padding={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 3 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 2, md: 0 }}
          paddingRight={{ xs: 2, md: 0 }}
          style={{ zIndex: 1 }}
        >

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
            }}
          >

            <Paper
              sx={{
                paddingTop: 2, paddingBottom: 1, paddingLeft: 2, paddingRight: 2,
                background: '#bfdae3ff',
                background: '#edf2f3ff',
              }}
              elevation={6}
            >

              <Swiper
                style={{
                  '--swiper-navigation-color': '#4d3df4ff',
                  '--swiper-pagination-color': '#4d3df4ff',
                }}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper2"
              >

                {images.map((slide, idx) =>

                  <div key={idx}>

                    {console.log("images=", images)}

                    <SwiperSlide>
                      <img src={slide.path} />
                      <div class="text-overlay" hidden={verificaContieneCaratteri(slide.title)}>
                        <p>
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                              p: 0, m: 0,
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 18,
                              color: '#ffffff',
                            }}
                          >
                            {slide.title}
                          </Typography>
                        </p>
                        <p>
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                              p: 0, m: 0,
                              fontFamily: 'Arial',
                              fontWeight: 300,
                              fontSize: 14,
                              color: '#ffffff',
                            }}
                          >
                            {slide.subTitle}
                          </Typography>
                        </p>
                      </div>
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>

                  </div>

                )}

              </Swiper>

              <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={5}
                slidesPerView={5}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper"
              >
                {images.map((slide, idx) =>

                  <div key={idx}>

                    {console.log("images=", images)}

                    <SwiperSlide title={slide.title} >
                      <img src={slide.path} />
                    </SwiperSlide>

                  </div>
                )}
              </Swiper>

            </Paper>

          </Box>

        </Grid>

        <Grid
          size={{ xs: 1, md: 1 }}
          padding={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 4 }}
          padding={{ xs: 2, md: 0 }}
        >

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6',
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Stack
              spacing={0}
              sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: 1, paddingLeft: 3, paddingRight: 0, }}
            >

              <Typography variant="body1"
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 700,
                  fontSize: { xs: 24, md: 30 },
                  color: 'text.primary',
                  paddingTop: 1
                }}
              >
                {service.name}
              </Typography>

              <Typography variant="body2"
                sx={{
                  color: 'text.secondary',
                  fontSize: 20,
                  paddingTop: 1
                }}
              >
                {service.description}
              </Typography>

              <Typography variant="body2"
                sx={{
                  fontFamily: 'sans-serif',
                  fontStyle: 'italic',
                  fontWeight: 300,
                  color: 'text.secondary',
                  fontSize: 12,
                  paddingTop: 2,
                  paddingRight: 3,
                }}
              >
                {service.note}
              </Typography>

              <Grid container spacing={2}
                sx={{
                  paddingTop: 2,
                  paddingRight: 2,
                }}
              >

                <Grid size={5}>
                  <Item>
                    <Typography variant="body2"
                      sx={{
                        color: 'text.secondary',
                        fontSize: 14,
                      }}
                    >
                      Prezzo &nbsp; <b>{strEuroCurrency(service.price)}</b>
                    </Typography>
                  </Item>
                </Grid>

                <Grid size={5}>
                  <Item>
                    <Typography variant="body2"
                      sx={{
                        color: 'text.secondary',
                        paddingTop: 0,
                        fontSize: 14,
                      }}
                    >
                      <Rating
                        readOnly
                        size="small"
                        name="half-rating"
                        initialValue={service.rating}
                        precision={0.5}
                      />
                      ({service.reviewsNumber ? service.reviewsNumber : 0})
                    </Typography>
                  </Item>
                </Grid>

                <Grid size={2}>
                  <Item>
                    <Link to={url_elencoServizi}>
                      <Tooltip title={help_image_elencoServizi} arrow placement="right-end">
                        <Box
                          component="img"
                          paddingTop={{ xs: 0, md: 0 }}
                          paddingLeft={{ xs: 0, md: 0 }}
                          sx={{
                            height: size_linkToAllServices,
                            width: size_linkToAllServices,
                            maxHeight: { xs: size_linkToAllServices, md: size_linkToAllServices },
                            maxWidth: { xs: size_linkToAllServices, md: size_linkToAllServices },
                          }}
                          src={url_image_elencoServizi}
                          onClick={event => {
                            navigate(url_elencoServizi)
                          }}
                        >
                        </Box>
                      </Tooltip>
                    </Link>

                  </Item>
                </Grid>
              </Grid>

            </Stack>

          </Paper>
        </Grid>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>
  );
};

export default ServiceDetailsPageComponent;
